import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { LorryService } from "../../../services/index";
import * as fromCommonStore from "../../../store";
import { PrintLRData } from "./print";

@Component({
  selector: "invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./lorry.html",
})
export class LorryInvoice implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  invoiceData: any[];

  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  partyCtrl: FormControl = new FormControl();
  partyList$ = [];
  partyList: Observable<any[]>;

  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "lr.ref_no",
    orderDir: "desc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    ref_no: "",
    transport: "",
  };

  partyStoreSub;
  itemStoreSub;
  invoiceStoreSub;

  printConfig: any = {
    title: "Sales Invoice",
    columns: [],
    rows: [],
  };
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private lrService: LorryService,
    private modalService: BsModalService,
    public toasterService: ToasterService
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;
           */
    this.invoiceStoreSub = this.store
      .select(fromRootStore.getLoadInvoice)
      .subscribe((isLoad: any) => {
        if (isLoad) {
          this.getInvoiceList();
        }
      });

    this.partyStoreSub = this.store
      .select(fromCommonStore.getAllParty)
      .subscribe((res: any) => {
        if (_.isEmpty(res)) {
          return;
        }
        this.partyList$ = res.data;
      });

    /*  this.partyList = this.partyCtrl.valueChanges
              .startWith(null)
              .map(name => name ? this.filterItems(name, 'Party') : this.partyList$.slice());*/
  }

  ngOnInit(): void {
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: true, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        isPrint: false,
      },
      {
        name: "Ref No",
        prop: "ref_no",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
        headerClass: "text-center",
        align: "right",
        type: "number",
      },
      {
        name: "LR Date",
        prop: "lrdate",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
        align: "right",
        type: "number",
      },
      {
        name: "Transport",
        prop: "transport",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
        headerClass: "text-center",
        align: "right",
        type: "number",
      },
      {
        name: "Action",
        prop: "action",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
        isPrint: false,
      },
    ];

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
      if (event.altKey && event.keyCode === 65) {
        this.addEditInvoice("Add", "");
      }
      if (event.keyCode === 27) {
        //  this.bsModalRef.hide();
      }
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterinvno").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getInvoiceList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    }
    if (nextEl == "applyFilter") {
      this.applyFilter();
    } else {
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getInvoiceList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getInvoiceList();
  }

  getInvoiceList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      ref_no: this.filterData.ref_no || "",
      transport: this.filterData.transport || "",
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllInvoice(params));
    this.isLoadMask = this.lrService
      .getLRDelivery(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.invoiceData = res.data;

        that.printConfig = {
          title: "Purchase Invoice",
          sumtitle: "TOTAL",
          columns: that.columns,
          rows: res.data,
        };
      });
  }

  bsModalRef: BsModalRef;
  print(row: any) {
    this.bsModalRef = this.modalService.show(PrintLRData, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "compWidth-70",
    });
    this.bsModalRef.content.printcontent = Object.assign({}, row);
  }

  clearFilter(): void {
    this.filterData.ref_no = "";
    this.filterData.transport = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getInvoiceList();
  }

  /*  filterItems(name: string, comboType: string) {
          let list: any[];
          if (comboType == "Party") {
              list = this.partyList$
          }
          name = _.escapeRegExp(name);
          return list.filter(item => (new RegExp(name, 'gi').test(item.name)));
      }*/

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Party") {
      list = this.partyList$;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  addEditInvoice(mode: string, row: any): void {
    this.filterExpand = true;

    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.filterExpand = true;
      this.getInvoiceList();
    });
    row.tabevent = listUpdateEvent;

    let tabObj = {
      action: "NewTab",
      params: {
        tabParent: "CLOTH",
        tabName: "LR DETAILS",
        id: "AddEditLorryInvoice",
        name: "LR Details",
        mode: mode,
        data: row,
      },
    };

    this.tabUpdateEvent.emit(tabObj);
  }

  deleteInvoice(row: any): void {
    let params = {
      lr_id: row.lr_id,
      lr_no: row.lr_no,
      inv_id: row.inv_id,
    };
    let that = this;
    row.tabevent = undefined;
    swal({
      title: "Are you sure to delete this Details?",
      text: "You will not be able to recover this Details",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.lrService
          .deleteLorryDet(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getInvoiceList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }

  @ViewChild("printPage") printPage;
  onPrintInvoice(row) {
    this.printConfig = {
      type: "invoice",
      title: "Sales Invoice",
      rows: row,
    };

    setTimeout(() => {
      this.printPage.printPreview();
    }, 100);
  }

  ngOnDestroy() {
    this.partyStoreSub.unsubscribe();
    this.invoiceStoreSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/lorryDetails/lorry.ts